export default __webpack_public_path__ + "static/ShamelFamily-SansBook-48acba302b2f365b691f59f94cd82a82.ttf";